import React, { useState } from "react";

function Sidebar() {
  const [showSidebar, setShowSidebar] = useState(false);
  return (
    <div className="sidebar-container">
      <button
        className="show-sidebar-button"
        onClick={() => setShowSidebar(true)}
      >
        <i className="fas  fa-list"></i> Contents
      </button>

      <div className={showSidebar ? "sidebar show" : "sidebar"}>
        <i
          className="fas close-sidebar-button  fa-times"
          onClick={() => setShowSidebar(false)}
        ></i>
        <div className="title">HTML Contents</div>

        <ul>
          <li>An introduction to HTML</li>
          <li>HTML Head Element</li>
          <li>HTML Text Fundamentals</li>
          <li>HTML Hyperlinks</li>
          <li>HTML Lists</li>
          <li>HTML Tables</li>
          <li>HTML Layout Tags</li>
          <li>An introduction to HTML</li>
          <li>HTML Head Element</li>
          <li>HTML Text Fundamentals</li>
          <li>HTML Hyperlinks</li>
          <li>HTML Lists</li>
          <li>HTML Tables</li>
          <li>HTML Layout Tags</li>
          <li>An introduction to HTML</li>
          <li>HTML Head Element</li>
          <li>HTML Text Fundamentals</li>
          <li>HTML Hyperlinks</li>
          <li>HTML Lists</li>
          <li>HTML Tables</li>
          <li>HTML Layout Tags</li>
          <li>An introduction to HTML</li>
          <li>HTML Head Element</li>
          <li>HTML Text Fundamentals</li>
          <li>HTML Hyperlinks</li>
          <li>HTML Lists</li>
          <li>HTML Tables</li>
          <li>HTML Layout Tags</li>
        </ul>
      </div>
    </div>
  );
}

export default Sidebar;
